<!-- @format -->

<div class="dashboard">
	<!-- SIDEBAR OVERLAY (mobile) -->
	<div
		class="sidebar-overlay"
		[class.active]="sidebarService.sidebarOpen$ | async"
		(click)="sidebarService.closeSidebar()"></div>

	<!-- SIDEBAR -->
	<div class="side-nav" [class.open]="sidebarService.sidebarOpen$ | async">
		<app-sidebar></app-sidebar>
	</div>

	<!-- MAIN SECTION -->
	<div class="main-content">
		<!-- HEADER -->
		<app-header></app-header>
		<!-- PAGE BODY -->
		<main>
			<router-outlet></router-outlet>
		</main>
	</div>
</div>
